module.exports = __webpack_public_path__ + "assets/img/ebook-cover_7criteres.0f4cced2.jpg";